import { AppLayout } from 'presentation/components';

import DashboardViewNew from 'presentation/pages/dashboard/DashboardViewNew';
import { useAuthContext } from 'context/useAuthContext';
import { QueueContextProvider } from 'presentation/components/Queue/QueueContext';
import React from 'react';
import { useClearReportOnNavigation } from '../../../../hooks/useClearReportOnNavigation';

export const NewDashboardViewFactory = (): JSX.Element => {
  const { user } = useAuthContext();
  const meId = user?.uid;

  useClearReportOnNavigation();

  return (
    <AppLayout noFooter={true}>
      <QueueContextProvider meId={meId}>
        <DashboardViewNew />
      </QueueContextProvider>
    </AppLayout>
  );
};
